var App = App || {};

App.Bios = (function ($) {
    "use strict";

    function init() {
        const bios = $(".block.block-bios");
        const activeClass = "active-bio";

        if (bios.length) {
            bios.each(function () {
                var thisBlock = $(this);
                var bioButtons = thisBlock.find(".btn.item-bio");
                var bioContents = thisBlock.find(".bio-contents .bio-content");
                var bioContentsMobile = thisBlock.find(".bio-content.mobile");
                var bioContentsTablet = thisBlock.find(".bio-contents.tablet .bio-content");

                bioButtons.each(function () {
                    $(this).on("click", function () {
                        var clickedButton = $(this);
                        var clickedId = clickedButton.attr("aria-controls");
                        var clickedActive = false;

                        if (clickedButton.hasClass(activeClass)) {
                            clickedActive = true;
                        }

                        bioButtons.removeClass(activeClass).attr("aria-expanded", false);
                        bioContents.removeClass(activeClass);
                        bioContentsMobile.removeClass(activeClass);
                        bioContentsTablet.removeClass(activeClass);

                        if (!clickedActive) {
                            clickedButton.addClass(activeClass).attr("aria-expanded", true);
                            $("#" + clickedId).addClass(activeClass)
                            $("#mobile-" + clickedId).addClass(activeClass)
                            $("#tablet-" + clickedId).addClass(activeClass)
                        }
                    });
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Bios.init();
});